import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./components/i18n";

ReactDOM.render(
  <BrowserRouter basename="/Fair">
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);